export default class HelperMask {
  static removeCepMask = (cep: string): string => cep.replace(/\D/g, "");

  static removeCpfMask = (cpf: string): string => cpf.replace(/\D/g, "");

  static removePhoneMask = (phone: string): string => phone.replace(/\D/g, "");

  static removeCnpjMask = (cnpj: string): string => cnpj.replace(/\D/g, "");
}
